module.exports = __webpack_public_path__ + "img/airport.37f0cbb9.png";